import React from "react";
import {
  _goToOrders,
  _goToAboutUs,
  _goToProfile,
  _goToContactUs,
} from "router/helper";

import {
  View,
  ScrollView,
  StyleSheet,
  SafeAreaView,
  StatusBar,
} from "react-native";
import { Logout, Separator } from "component";
import Item from "./Item";
import ItsaLink from "./ItsaLink";
import DrawerHeader from "./DrawerHeader";

import { colors, sizes, strings } from "asset/constant";
import { css } from "style";
import { mq } from "utils";
import tinycolor from "tinycolor2";
import { useRecoilValue } from "recoil";
import { authAtom } from "store";

const ItemSeparator = () => (
  <Separator
    size={"70%"}
    color={tinycolor(colors.theme).lighten(60).toString()}
    sidesSpace={mq(2)}
  />
);

export default function Content() {
  const auth = useRecoilValue(authAtom);
  return (
    <>
      {auth?.user?.code ? (
        <SafeAreaView style={styles.container}>
          <DrawerHeader />

          <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
            <Item
              title={strings.profile}
              icon={{ name: "user" }}
              onPress={_goToProfile}
            />
            <ItemSeparator />

            <Item
              title={strings.orders}
              icon={{ name: "profile" }}
              onPress={_goToOrders}
            />
            <ItemSeparator />

            <Item
              title={strings.contact_us}
              icon={{ name: "phone" }}
              onPress={_goToContactUs}
            />
            <ItemSeparator />

            <Item
              title={strings.about_us}
              icon={{ name: "infocirlceo" }}
              onPress={_goToAboutUs}
            />
            <ItemSeparator />

            <View style={{ marginRight: 6 }}>
              <Logout />
            </View>
          </ScrollView>
          <View style={css.container} />
          <ItsaLink />
        </SafeAreaView>
      ) : (
        <></>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: "hidden",
    paddingTop: StatusBar.currentHeight + sizes.space,
  },
});
